import * as React from 'react';
import { JSXElementConstructor } from 'react';

type ComponentEntry<T = any> = React.ComponentType<T> | [React.ComponentType<any>, { [key: string]: any }];

export type ComponentAndPropEntry<T extends keyof JSX.IntrinsicElements | JSXElementConstructor<any>> = [
    React.ComponentType<React.ComponentProps<T>>,
    React.ComponentProps<T>
];

interface IProps {
    components: ComponentEntry[];
}

export const ComposeProviders: React.FunctionComponent<IProps> = (
    {
        components,
        children
    }
) => (
    <React.Fragment>
        {
            components
                .reverse()
                .reduce(
                    (providerChain, entry) => {
                        const [Provider, props] = Array.isArray(entry) ? [entry[0], entry[1]] : [entry, {}];
                        return (
                            <Provider {...props}>{providerChain}</Provider>
                        );
                    },
                    children
                )
        }
    </React.Fragment>
);



// WEBPACK FOOTER //
// ./src/utils/compose-providers.tsx